var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMobileMenuLogoSvg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 40,
    viewBox: "0 0 56 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2801_23435)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M33.1995 2.6008C31.1995 1.21764 27.8438 0 27.8438 0C27.8438 0 24.4882 1.21764 22.4887 2.6008C19.6789 4.5441 18.1835 6.74456 18.1835 9.77033V39.7761H37.5048V9.77033C37.5048 6.74456 36.0094 4.5441 33.1995 2.6008Z",
    fill: "#FBF4EC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.95606 39.776H15.9114V14.4072C15.9114 11.351 14.68 9.12881 12.3661 7.16661C10.7195 5.76971 7.95606 4.54004 7.95606 4.54004C7.95606 4.54004 5.19317 5.76971 3.54598 7.16661C1.23212 9.12881 0.000732422 11.351 0.000732422 14.4072V39.776H7.95606Z",
    fill: "#FBF4EC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.7328 39.776H55.6875V14.4072C55.6875 11.351 54.4561 9.12881 52.1423 7.16661C50.4956 5.76971 47.7322 4.54004 47.7322 4.54004C47.7322 4.54004 44.9687 5.76971 43.3221 7.16661C41.0088 9.12881 39.7769 11.351 39.7769 14.4072V39.776H47.7328Z",
    fill: "#FBF4EC"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2801_23435"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 56,
    height: 40,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMobileMenuLogoSvg);
export default __webpack_public_path__ + "static/media/MobileMenuLogoSVG.e1271f0aed1c2a92159b188f01ecaa26.svg";
export { ForwardRef as ReactComponent };